export default {
  'Admin Notes': {
    en: 'Admin Notes',
    ja: 'Admin Notes',
    et: 'Admin Notes',
    lt: 'Admin Notes',
    ch: 'Admin Notes',
    ph: 'Admin Notes',
  },
  All: {
    en: 'All',
    ja: 'All',
    et: 'All',
    lt: 'All',
    ch: 'All',
    ph: 'All',
  },
  Branch: {
    en: 'Branch',
    ja: 'Branch',
    et: 'Branch',
    lt: 'Branch',
    ch: 'Branch',
    ph: 'Branch',
  },
  'Characteristic UUID': {
    en: 'Characteristic UUID',
    ja: 'Characteristic UUID',
    et: 'Characteristic UUID',
    lt: 'Characteristic UUID',
    ch: 'Characteristic UUID',
    ph: 'Characteristic UUID',
  },
  'Created At': {
    en: 'Created At',
    ja: 'Created At',
    et: 'Created At',
    lt: 'Created At',
    ch: 'Created At',
    ph: 'Created At',
  },
  'Created Date': {
    en: 'Created Date',
    ja: 'Created Date',
    et: 'Created Date',
    lt: 'Created Date',
    ch: 'Created Date',
    ph: 'Created Date',
  },
  'Create Vivivault': {
    en: 'Create Vivivault',
    ja: 'Create Vivivault',
    et: 'Create Vivivault',
    lt: 'Create Vivivault',
    ch: 'Create Vivivault',
    ph: 'Create Vivivault',
  },
  'Delete Vivivault': {
    en: 'Delete Vivivault',
    ja: 'Delete Vivivault',
    et: 'Delete Vivivault',
    lt: 'Delete Vivivault',
    ch: 'Delete Vivivault',
    ph: 'Delete Vivivault',
  },
  'Device Name': {
    en: 'Device Name',
    ja: 'Device Name',
    et: 'Device Name',
    lt: 'Device Name',
    ch: 'Device Name',
    ph: 'Device Name',
  },
  'Download QR Code': {
    en: 'Download QR Code',
    ja: 'Download QR Code',
    et: 'Download QR Code',
    lt: 'Download QR Code',
    ch: 'Download QR Code',
    ph: 'Download QR Code',
  },
  'Download Arduino File': {
    en: 'Download Arduino File',
    ja: 'Download Arduino File',
    et: 'Download Arduino File',
    lt: 'Download Arduino File',
    ch: 'Download Arduino File',
    ph: 'Download Arduino File',
  },
  'Edit Vivivault': {
    en: 'Edit Vivivault',
    ja: 'Edit Vivivault',
    et: 'Edit Vivivault',
    lt: 'Edit Vivivault',
    ch: 'Edit Vivivault',
    ph: 'Edit Vivivault',
  },
  Expired: {
    en: 'Expired',
    ja: 'Expired',
    et: 'Expired',
    lt: 'Expired',
    ch: 'Expired',
    ph: 'Expired',
  },
  'Expire At': {
    en: 'Expire At',
    ja: 'Expire At',
    et: 'Expire At',
    lt: 'Expire At',
    ch: 'Expire At',
    ph: 'Expire At',
  },
  'Generate Characteristic UUID': {
    en: 'Generate Characteristic UUID',
    ja: 'Generate Characteristic UUID',
    et: 'Generate Characteristic UUID',
    lt: 'Generate Characteristic UUID',
    ch: 'Generate Characteristic UUID',
    ph: 'Generate Characteristic UUID',
  },
  'Generate Service UUID': {
    en: 'Generate Service UUID',
    ja: 'Generate Service UUID',
    et: 'Generate Service UUID',
    lt: 'Generate Service UUID',
    ch: 'Generate Service UUID',
    ph: 'Generate Service UUID',
  },
  'No Results': {
    en: 'No Results',
    ja: 'No Results',
    et: 'No Results',
    lt: 'No Results',
    ch: 'No Results',
    ph: 'No Results',
  },
  New: {
    en: 'New',
    ja: 'New',
    et: 'New',
    lt: 'New',
    ch: 'New',
    ph: 'New',
  },
  Save: {
    en: 'Save',
    ja: 'Save',
    et: 'Save',
    lt: 'Save',
    ch: 'Save',
    ph: 'Save',
  },
  'Service UUID': {
    en: 'Service UUID',
    ja: 'Service UUID',
    et: 'Service UUID',
    lt: 'Service UUID',
    ch: 'Service UUID',
    ph: 'Service UUID',
  },
  'This file is to be downloaded into the Arduino used for the Vivivault.': {
    en: 'This file is to be downloaded into the Arduino used for the Vivivault.',
    ja: 'This file is to be downloaded into the Arduino used for the Vivivault.',
    et: 'This file is to be downloaded into the Arduino used for the Vivivault.',
    lt: 'This file is to be downloaded into the Arduino used for the Vivivault.',
    ch: 'This file is to be downloaded into the Arduino used for the Vivivault.',
    ph: 'This file is to be downloaded into the Arduino used for the Vivivault.',
  },
  'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.': {
    en: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
    ja: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
    et: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
    lt: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
    ch: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
    ph: 'This is an empty QR Code. Please fill in the fields in "Vivivault Details" to download the correct QR Code.',
  },
  'This section is only available after creating Vivivault.': {
    en: 'This section is only available after creating Vivivault.',
    ja: 'This section is only available after creating Vivivault.',
    et: 'This section is only available after creating Vivivault.',
    lt: 'This section is only available after creating Vivivault.',
    ch: 'This section is only available after creating Vivivault.',
    ph: 'This section is only available after creating Vivivault.',
  },
  'Unlock Code': {
    en: 'Unlock Code',
    ja: 'Unlock Code',
    et: 'Unlock Code',
    lt: 'Unlock Code',
    ch: 'Unlock Code',
    ph: 'Unlock Code',
  },
  Vivivault: {
    en: 'Vivivault',
    ja: 'Vivivault',
    et: 'Vivivault',
    lt: 'Vivivault',
    ch: 'Vivivault',
    ph: 'Vivivault',
  },
  'Vivivault added': {
    en: 'Vivivault added',
    ja: 'Vivivault added',
    et: 'Vivivault added',
    lt: 'Vivivault added',
    ch: 'Vivivault added',
    ph: 'Vivivault added',
  },
  'Vivivault Assets': {
    en: 'Vivivault Assets',
    ja: 'Vivivault Assets',
    et: 'Vivivault Assets',
    lt: 'Vivivault Assets',
    ch: 'Vivivault Assets',
    ph: 'Vivivault Assets',
  },
  'Vivivault Arduino File': {
    en: 'Vivivault Arduino File',
    ja: 'Vivivault Arduino File',
    et: 'Vivivault Arduino File',
    lt: 'Vivivault Arduino File',
    ch: 'Vivivault Arduino File',
    ph: 'Vivivault Arduino File',
  },
  'Vivivault Code': {
    en: 'Vivivault Code',
    ja: 'Vivivault Code',
    et: 'Vivivault Code',
    lt: 'Vivivault Code',
    ch: 'Vivivault Code',
    ph: 'Vivivault Code',
  },
  'Vivivault Details': {
    en: 'Vivivault Details',
    ja: 'Vivivault Details',
    et: 'Vivivault Details',
    lt: 'Vivivault Details',
    ch: 'Vivivault Details',
    ph: 'Vivivault Details',
  },
  'Vivivault modified': {
    en: 'Vivivault modified',
    ja: 'Vivivault modified',
    et: 'Vivivault modified',
    lt: 'Vivivault modified',
    ch: 'Vivivault modified',
    ph: 'Vivivault modified',
  },
  'Vivivault QR Code': {
    en: 'Vivivault QR Code',
    ja: 'Vivivault QR Code',
    et: 'Vivivault QR Code',
    lt: 'Vivivault QR Code',
    ch: 'Vivivault QR Code',
    ph: 'Vivivault QR Code',
  },
};
